import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { Id as GroupId } from '../group';

export const Group = intersect(
	struct({
		id: GroupId,
		name: string,
		layerIds: array(string),
	})
)(
	partial({
		parentId: string,
	})
);
